import React from "react";
import Nav from "./components/Nav";
import Main from "./components/Main";
import Footer from "./components/Footer";

function App() {
	return (
		<>
			<Nav />
			<Main />
			<Footer />
		</>
	);
}

export default App;
